import GuestsForm from 'components/common/MarchPromo/components/GuestsForm/GuestsForm'
import { GuestsDataContext } from 'components/common/MarchPromo/utils/guestsDataProvider'
import Box from 'components/shared/Box'
import { VoucherFormFooter } from 'components/shared/Promotions/components/MarchPromoInfo/components/VoucherFormFooter/VoucherFormFooter'
import { VoucherFormHeader } from 'components/shared/Promotions/components/MarchPromoInfo/components/VoucherFormHeader/VoucherFormHeader'
import { VoucherSelector } from 'components/shared/Promotions/components/MarchPromoInfo/components/VoucherSelector/VoucherSelector'
import Text from 'components/shared/Text'
import {
    PRODUCT_ID_MARCH_VOUCHER_PROLONGED,
    PRODUCT_ID_MARCH_VOUCHER_STANDARD,
} from 'constants/app'
import { MARCH_PROMO_STANDARD_VOUCHER_PRICE } from 'constants/prices'
import { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { CancelButton, VoucherFormContainer } from './styles'

interface VoucherFormProps {
    onCancel: () => void
    onSuccess: () => void
}

export const VoucherForm = ({ onCancel, onSuccess }: VoucherFormProps) => {
    const { totalPrice, voucherPrice } = useContext(GuestsDataContext)

    return (
        <VoucherFormContainer isFullWidth>
            <Box direction="column" gap={8} isFullWidth>
                <Box direction="row" justify="space-between" isFullWidth>
                    <Text variant="heading3" color="grayscale_900">
                        <FormattedMessage
                            id="promo.march.voucher_selector_title"
                            defaultMessage="Wybierz ważność voucherów promocyjnych"
                        />
                    </Text>
                    <CancelButton onClick={onCancel}>
                        <FormattedMessage
                            id="global.btn.cancel"
                            defaultMessage="Anuluj"
                        />
                    </CancelButton>
                </Box>
                <Text variant="bodySmall" color="grayscale_800">
                    <FormattedMessage
                        id="promo.march.voucher_selector_description"
                        defaultMessage="Promocyjne vouchery możesz wykorzystać na miejscu, bez wcześniejszej rezerwacji wizyty."
                    />
                </Text>
            </Box>
            <VoucherSelector />
            {!!totalPrice && !!voucherPrice && (
                <>
                    <VoucherFormHeader />
                    <GuestsForm
                        voucherProductId={
                            voucherPrice === MARCH_PROMO_STANDARD_VOUCHER_PRICE
                                ? PRODUCT_ID_MARCH_VOUCHER_STANDARD
                                : PRODUCT_ID_MARCH_VOUCHER_PROLONGED
                        }
                        voucherPrice={voucherPrice}
                    />
                    <Text variant="bodySmall" color="grayscale_800">
                        <FormattedMessage
                            id="promo.march.voucher_form_return_policy_info"
                            defaultMessage="Uwaga! Zamówienie zawierające vouchery promocyjne staje się bezzwrotne w momencie dokonania płatności. Nie można też go edytować."
                        />
                    </Text>
                    <div className="divider" />
                    <VoucherFormFooter
                        onCancel={onCancel}
                        onSuccess={onSuccess}
                    />
                </>
            )}
        </VoucherFormContainer>
    )
}
